export default __webpack_public_path__ + "static/media/gabrielatorres.697de619.png";